const DiffSymbolEnum = {
  Left: {
    value: -1,
    text: '左だけにある',
    backgroundColor: '#FDB9C1'
  },
  Common: {
    value: 0,
    text: '両方にある',
    backgroundColor: 'transparent'
  },
  Right: {
    value: 1,
    text: '右だけにある',
    backgroundColor: '#ABF2BC'
  }
};
export default DiffSymbolEnum;



// WEBPACK FOOTER //
// ./src/constants/contract_diff/diff_symbol.js